import ReactDOM from "react-dom/client";
import { createElement, useEffect } from "react";
import * as components from "nystem-components";

// React's root render returns before lazy Index has mounted.
const LoadingReady = ({ app, component }) => {
  useEffect(() => {
    app.event("pageLoading", { visible: false });
  }, [app]);
  return createElement(components[component], {});
};

let base = document.getElementById("root");

if (!base) {
  base = document.createElement("div");
  base.id = "root";
  document.body.appendChild(base);
}

export default (app) => {
  const loadDom = async () => {
    const { renderer, component, element } = await app.event("getElementContext", {
      renderer: ReactDOM,
      component: "Index",
      element: base,
    });

    if (!app.domRoot) app.domRoot = renderer.createRoot(element);
    app.domRoot.render(createElement(LoadingReady, { app, component }));
  };

  app.on("loaded", loadDom);

  app.on("unmount", () => {
    app.domRoot.unmount();
    app.domRoot = undefined;
  });
};
